<div class="gradient-bounce gradient-bounce-top"></div>
<div class="gradient-bounce gradient-bounce-bottom"></div>
